/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgKeys32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M9.654 4.145a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm.75 2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M9.654 1.145a7.25 7.25 0 013.215 13.75h.035v13.36l-3.25 2.6-3.25-2.6v-2.67l1.69-1.69-1.69-1.69v-2.62l.69-.69-.69-.69v-3.31h.035a7.25 7.25 0 013.215-13.75zm5.75 7.25a5.75 5.75 0 10-11.5 0 5.75 5.75 0 0011.5 0zm-4 19.14V15.431a7.266 7.266 0 01-3.5 0v2.152l1.31 1.31-1.31 1.311v1.38l2.31 2.31-2.31 2.31v1.33l1.75 1.4 1.75-1.4z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M21.831 6.539a5.74 5.74 0 00-4.27-2.832l.186-1.488a7.25 7.25 0 015.16 11.184l6.69 11.585-1.515 3.877-4.115-.627-1.336-2.313.619-2.308L20.942 23l-1.31-2.27.252-.942-.942-.252-1.664-2.882a7.258 7.258 0 01-1.762-.113l.276-1.474a5.75 5.75 0 006.039-8.527zm6.106 18.575l-6.051-10.48c-.416.4-.887.757-1.41 1.058a7.26 7.26 0 01-1.622.691l1.076 1.864 1.79.48-.479 1.79.69 1.194 3.156.846-.846 3.156.665 1.151 2.215.337.816-2.087z'
      />
    </svg>
  );
}

export default SvgKeys32;
